import Head from "next/head"
import { FC, PropsWithChildren } from "react"

const BlogLayout: FC<PropsWithChildren<{ title?: string }>> = ({ title, children }) => {
  return (
    <>
      <Head>
        <title>{title || "Superwall"}</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main className={`dark:bg-grayscale-darkest flex-grow`}>{children}</main>
    </>
  )
}

export default BlogLayout
